<template>
  <div>
    <button
      v-b-tooltip.hover
      v-b-modal="'addNewFeedEntry' + modalId"
      type="button"
      placement="bottom"
      title="Neuer Feed-Eintrag erstellen"
      class="btn btn-success"
      @click="createNewFeedEntry"
    >
      <i class="fas fa-plus" />
    </button>
    <b-modal
      :id="'addNewFeedEntry' + modalId"
      :ref="'addNewFeedEntry' + modalId"
      no-fade
      hide-footer
      size="xl"
      title="Neuer Feed-Eintrag erstellen"
    >
      <div class="d-block mb-4">
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
          :property-mapping="createErrorPropertyMappings()"
        />
        <u-loader v-show="isLoading" />
        <div v-if="!isLoading && newFeedEntry != null">
          <EditFeedEntry
            v-model="newFeedEntry"
            :editable="editable"
          />
        </div>
        <b-button
          variant="success"
          @click="saveNewEntry()"
        >
          Hinzufügen
        </b-button>
        <b-button
          class="ml-2"
          variant
          @click="hideModal"
        >
          Abbrechen
        </b-button>
      </div>
    </b-modal>
  </div>
</template>

<script>
import EditFeedEntry from "@/components/rssFeed/EditFeedEntry.vue";
import { CreateNewEntry } from "@/services/rssFeed.service.js";
export default {
  components: {
    EditFeedEntry,
  },
  props: {
    modalId: {
      type: String,
      default: "addButton",
    },
    tenantId: {
      type: Number,
      default: null,
    },
    publicationId: {
      type: Number,
      default: 0,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      newFeedEntry: null,
      isLoading: false,
      errorObject: null,
      allLanguages: [
        { name: "Deutsch", value: "de-CH" },
        { name: "Französisch", value: "fr-CH" },
        { name: "Italienisch", value: "it-CH" },
      ],
    };
  },
  methods: {
    createNewFeedEntry() {
      this.newFeedEntry = null;
      this.errorObject = null;

      setTimeout(() => {
        this.newFeedEntry = {
          id: 0,
          publicationId: this.publicationId,
          publicationDate: null,
          status: 1,
          feedEntryContents: [
            {
              id: 0,
              feedId: 0,
              value: "",
              url: "",
              language: "de-CH",
            },
            {
              id: 0,
              feedId: 0,
              value: "",
              url: "",
              language: "fr-CH",
            },
            {
              id: 0,
              feedId: 0,
              value: "",
              url: "",
              language: "it-CH",
            },
          ],
          tenants: [],
        };

        if (this.tenantId) {
          this.newFeedEntry.tenants.push(this.tenantId);
        }
      }, 50);
    },
    hideModal() {
      this.$refs["addNewFeedEntry" + this.modalId].hide();
    },
    saveNewEntry() {
      this.isLoading = true;
      this.errorObject = null;

      CreateNewEntry(
        this.newFeedEntry,
        () => {
          this.isLoading = false;
          this.hideModal();
          this.newFeedEntry = null;
          this.$emit("feedAdded");
        },
        (error) => {
          this.errorObject = error;
          this.isLoading = false;
        },
      );
    },
    createErrorPropertyMappings() {
      var mapping = {};

      this.allLanguages.map((language, index) => {
        mapping[`FeedEntryContents[${index}].Url`] = `Url ${language.name}`;
      });

      this.allLanguages.map((language, index) => {
        mapping[`FeedEntryContents[${index}].Title`] = `Titel ${language.name}`;
      });

      this.allLanguages.map((language, index) => {
        mapping[`FeedEntryContents[${index}].Text`] = `Text ${language.name}`;
      });

      return mapping;
    },
  },
};
</script>

<style lang="scss" scoped></style>
